import type { Theme } from '@mui/material';

export const styles = {
  svgIcon: (theme: Theme) => ({
    height: 'auto',
    width: 'auto',

    '.doughnut-cls-1': {
      fill: theme.colors.doughnutNeutral,
    },
    '.doughnut-cls-2': {
      fill: theme.colors.doughnutPositive,
    },
    '.doughnut-cls-3': {
      fill: theme.colors.doughnutVeryPositive,
    },

    '.stacked-bar-cls-1': {
      fill: theme.colors.stackedVeryNegative,
    },
    '.stacked-bar-cls-2': {
      fill: theme.colors.stackedNegative,
    },
    '.stacked-bar-cls-3': {
      fill: theme.colors.stackedNeutral,
    },
    '.stacked-bar-cls-4': {
      fill: theme.colors.stackedPositive,
    },
    '.stacked-bar-cls-5': {
      fill: theme.colors.stackedVeryPositive,
    },
  }),
};
